import React, { useEffect, useState } from "react";
import ModalSkeleton from "../ModalSkeleton";
import classes from "./ViewVideo.module.css";
import { TextArea } from "../../Component/TextArea";
import { Button } from "../../Component/Button/Button";
import ReactPlayer from "react-player";

const ViewVideoModal = ({ show, setShow, data, setSelectedItem }) => {
  return (
    <div>
      <ModalSkeleton
        setShow={setShow}
        show={show}
        width={"650px"}
        borderRadius={"20px"}
        header={"View Video"}
      >
        <div className={classes.playerDiv}>
          <ReactPlayer
            playing
            width={"100%"}
            height={"100%"}
            // light={<img src={thumbnail} alt='Thumbnail' />}
            url={data?.fromGallery ? data?.gallery?.video : data?.video}
            controls={true}
          />
        </div>
      </ModalSkeleton>
    </div>
  );
};

export default ViewVideoModal;
